import { IResourceComponentsProps, useForm } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import { ChildForm } from "interfaces/schemaDB";

export const FragmentPubsEdit: React.FC<IResourceComponentsProps> = () => {
    const resourceLabel :string = 'Fragmento.';
    const resourceName :string = 'fragmentPub';
    const { id } = useForm({
        resource : resourceName
        // , id: 15
    });
    const childrenForms : ChildForm[] =[
        {
            resourceName :"fragmentObject",
            title : "Imágenes",
            field : "fro_id_fragmento"
        },     
        {
          resourceName :"recursoInfografia",
          title : "Recurso",
          field : "rec_id_infografia",
          createModal : true,
          editModal : true,       
          showCards : false,
      
        }           
    ]

    return(
        <Cw8EditWrapper
            resourceLabel = {resourceLabel}
            resourceName = {resourceName}
            id = {id}
            childrenForms = {childrenForms}
        ></Cw8EditWrapper>
    )
};
